import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';
import { PlannerHelpingService } from './planner-helping-service';
@Injectable({
  providedIn: 'root'
})
export class PlannerJspritService {

  user;
  preData;
  preFleet;
  selectedMapper;
  violation;
  timeCalibration;
  selectedDrivers;
  selectedMethod;
  preDrivers;
  shiftMapper;

  constructor(private  assigTripsService:AssigTripsService,
      private plannerHelpingService: PlannerHelpingService) {
  }

  async planTrips(user, preData, preFleet, violation, selectedMapper, selectedDrivers, selectedMethod, timeCalibration, manifestTrips, preDrivers, shiftMapper) {
    this.user = user;
    this.preData = preData;
    this.preFleet = preFleet;
    this.violation = violation;
    this.timeCalibration = timeCalibration;
    this.selectedMapper = selectedMapper;
    this.shiftMapper = shiftMapper;
    this.selectedDrivers = selectedDrivers;
    this.selectedMethod = selectedMethod;
    this.preDrivers = preDrivers

    let planedTrips = {
      trips: [],
      nonCompatible: [],
      compatible: {},
      tripLogs: {},
      driversDistance: {}
    };

    for (let trip of this.preData.trips) {
      if (this.preData.selectedTrips.includes(trip._id)) {
        planedTrips.trips.push(trip);
      }
    }

    // if (this.timeCalibration && this.timeCalibration !== "none") {
    //   // set pickup and drop off time
    //   for (let trip of planedTrips.trips) {
    //     const distance = await this.calculateDistance(
    //       trip.jobOriginLatitude,
    //       trip.jobOriginLongitude,
    //       trip.jobDestinationLatitude,
    //       trip.jobDestinationLongitude
    //     );

    //     if (distance && distance.duration) {
    //       if (timeCalibration === "pickup-wise") {
    //         trip.scheduleTime = moment(trip.appointmentTime).tz(user.timeZone).subtract(distance.duration, 'minutes').toISOString();
    //       } else if (timeCalibration === "dropoff-wise") {
    //         trip.appointmentTime = moment(trip.scheduleTime).tz(user.timeZone).add(distance.duration, 'minutes').toISOString();
    //       } else {

    //       }
    //     }
    //   }
    // }

 if (this.timeCalibration && this.timeCalibration !== "none") {
      if (this.timeCalibration === "pickup-wise") {
        await this.plannerHelpingService.applyPickupWiseCalibration(this.selectedMethod, planedTrips.trips, user);
      } else if (this.timeCalibration === "dropoff-wise") {
        await this.plannerHelpingService.applyDropoffWiseCalibration(this.selectedMethod, planedTrips.trips, user);
      } else {
        await this.plannerHelpingService.applyMemberWiseHybridCalibration(this.selectedMethod, planedTrips.trips, user);
      }
    }


    this.selectedDrivers.sort((a, b) =>
      a.displayName.localeCompare(
        b.displayName
      )
    );

    planedTrips.trips.sort((a, b) => {
      return moment(a.scheduleTime).tz(this.user.timeZone).diff(moment(b.scheduleTime).tz(this.user.timeZone));
    });


    // run from here
    const myTrips = await planedTrips.trips.map(item => ({
      tripId: item._id,
      personName: item.priorityClient.displayName,
      pickupLatitude: item.jobOriginLatitude,
      pickupLongitude: item.jobOriginLongitude,
      dropoffLatitude: item.jobDestinationLatitude,
      dropoffLongitude: item.jobDestinationLongitude,
      appointmentTime: item.appointmentTime,
      specialNeeds: item.spaceType
    }));

    const vehicles = await this.selectedDrivers.filter(driver => {
      const start = moment(this.preData.date).startOf('day');
      const end = moment(this.preData.date).endOf('day');
      if (this.shiftMapper[driver._id] && this.shiftMapper[driver._id].shifts && this.shiftMapper[driver._id].shifts.length) {
        const checkTodayShift = this.shiftMapper[driver._id].shifts.find(item => item.day == start.day() && item.isEnabled);
        if (checkTodayShift && checkTodayShift.checkin) {
          start.set({ hour: checkTodayShift.checkin.split(':')[0], minute: checkTodayShift.checkin.split(':')[1] });
          end.set({ hour: checkTodayShift.checkout.split(':')[0], minute: checkTodayShift.checkout.split(':')[1] });

          const driverFleetId = this.selectedMapper.mappers[driver._id];
          if (driverFleetId && this.preFleet[driverFleetId] && this.preFleet[driverFleetId].spaceType) {
            return true;
          }
        }
      }
      return false;
    }).map(driver => {
      const start = moment(this.preData.date).startOf('day');
      const end = moment(this.preData.date).endOf('day');
      if (this.shiftMapper[driver._id] && this.shiftMapper[driver._id].shifts && this.shiftMapper[driver._id].shifts.length) {
        const checkTodayShift = this.shiftMapper[driver._id].shifts.find(item => item.day == start.day() && item.isEnabled);
        if (checkTodayShift && checkTodayShift.checkin) {
          start.set({ hour: checkTodayShift.checkin.split(':')[0], minute: checkTodayShift.checkin.split(':')[1] });
          end.set({ hour: checkTodayShift.checkout.split(':')[0], minute: checkTodayShift.checkout.split(':')[1] });

          const driverFleetId = this.selectedMapper.mappers[driver._id];
          if (driverFleetId) {
            return {
              vehicleId: driver._id,
              name: driver.displayName,
              vehicleType: this.preFleet[driverFleetId].spaceType,
              latitude: driver.startingPointAddress.latitude,
              longitude: driver.startingPointAddress.longitude,
              earliestStart: start.toISOString(),
              latestArrival: end.toISOString(),
            };;
          }
        }
      }
    });


    const result = await this.assigTripsService.getRoutePlanning({
      vehicles,
      trips: myTrips
    }).toPromise();

    if (result) {

        if (result.routes) {
          for (const item of result.routes) {
            if (!planedTrips.compatible[item.vehicleId]) {
              planedTrips.compatible[item.vehicleId] = {
                driver: preDrivers[item.vehicleId],
                trips: [],
                stops: item.stops,
              };
            }

            let index = 1;
            for (const trip of item.stops) {
              const actualTrip = planedTrips.trips.find(t => t._id === trip.tripId);
              const tripData = planedTrips.compatible[item.vehicleId].trips.find(t => t._id === actualTrip._id);
              if (!tripData) {
                planedTrips.compatible[item.vehicleId].trips.push({ ...actualTrip, "stopType": trip.stopType + ' - ' + index, priority: index });
                index++;
              }
            }
          }
        }

        if (result.unassignedTrips) {
          for (const item of result.unassignedTrips) {
            const actualTrip = planedTrips.trips.find(t => t._id === item);
            planedTrips.nonCompatible.push(actualTrip);
          }
        }

    }


    // Object.values(planedTrips.compatible).forEach((driverAssignment: any) => {
    //   if (driverAssignment.trips && Array.isArray(driverAssignment.trips)) {
    //     driverAssignment.trips.forEach((t, idx) => {
    //       t.priority = idx + 1;
    //     });
    //   }
    // });
    // reset trips array after all planning
    planedTrips.trips = [];
    return planedTrips;

  }


  /**
 * Main method to assign trips to drivers.
 *
 * It iterates over trips (sorted by scheduleTime) and:
 * • Checks eligibility for each driver based on shift, fleet, funding, service area, and starting point.
 * • If a trip is from a client that already has an assigned driver (flag-based), it will only consider that driver.
 * • For each candidate driver, it ensures the trip fits into their current route.
 * • Finally, it chooses the best driver (minimizing added travel distance) and assigns the trip.
 *
 * @param {Array} trips - Array of trip objects.
 * @param {Array} drivers - Array of driver objects.
 * @returns {Object} A mapping from driver IDs to arrays of assigned trips.
 */
 async assignTripsToDrivers(planedTrips, drivers) {
    // Create a sorted copy of trips by scheduleTime (ascending).
    const clientDriverMap = {};  // { clientId: driverId } to enforce same-driver assignment for the same client

    for (let trip of planedTrips.trips) {
      // Use the priority client clientId if available; fallback to trip.client.
      const clientId = trip.priorityClient.displayName.toLowerCase();
      let candidateDrivers = [];
      let allDriversNearestTo = {};
      let isSameClient = false;

      if (this.violation && this.violation.prefferedToSameDriver && clientDriverMap[clientId]) {
        isSameClient = true;
        const driver = drivers.find((d) => d._id === clientDriverMap[clientId]);
        if (driver && this.isTripEligibleForDriver(planedTrips, trip, driver)) {
          candidateDrivers.push(driver);
        }
      } else {
        // Otherwise, consider all drivers who are eligible.
        candidateDrivers = drivers.filter((driver) => {
          const result = this.isTripEligibleForDriver(planedTrips, trip, driver);
          return result;
        }
        );
      }

      // Filter candidate drivers further by checking if the trip can be fit into their route.
      let feasibleDrivers =  await this.checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo);

      if (feasibleDrivers.length === 0 && isSameClient) {
        console.warn(`Trip ${trip.tripId}. ${trip.priorityClient.displayName} could not be assigned based on current criteria. Rechecking with other drivers`);
        isSameClient = false;
        //consider all drivers who are eligible.
        candidateDrivers = drivers.filter((driver) => {
          const result = this.isTripEligibleForDriver(planedTrips, trip, driver);
          return result;
        });

         // Filter candidate drivers further by checking if the trip can be fit into their route.
        feasibleDrivers = await this.checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo);
      }

      if (feasibleDrivers.length > 0) {
        // Choose the best driver (minimize extra travel distance).
        const chosenDriver = await this.chooseDriverForTrip(clientDriverMap[clientId], feasibleDrivers, allDriversNearestTo, trip, planedTrips.compatible);
        if (planedTrips.compatible[chosenDriver.driver._id]) {
          const selectedTripDistance = await this.calculateDistance(trip.jobOriginLatitude, trip.jobOriginLongitude, trip.jobDestinationLatitude, trip.jobDestinationLongitude);
          // calculate distance between trip points
          if (!planedTrips.driversDistance[chosenDriver.driver._id]) planedTrips.driversDistance[chosenDriver.driver._id] = 0;
          planedTrips.driversDistance[chosenDriver.driver._id] += selectedTripDistance.distance;


          if (chosenDriver.index) {
            console.log("Push at chosenDriver.index", chosenDriver.index,(planedTrips.compatible[chosenDriver.driver._id].trips.length-1) );
            // push at specific index
            planedTrips.compatible[chosenDriver.driver._id].trips.splice(chosenDriver.index, 0, trip);
          } else {
            planedTrips.compatible[chosenDriver.driver._id].trips.push(trip);
          }



        } else {
          planedTrips.compatible[chosenDriver.driver._id] = {
            driver: chosenDriver.driver,
            trips: [trip]
          }
        }

        // Ensure subsequent trips for the same client are assigned to this driver.
        clientDriverMap[clientId] = chosenDriver.driver._id;
      } else {
        planedTrips.nonCompatible.push(trip);
        console.warn(`Trip ${trip.tripId}. ${trip.priorityClient.displayName} could not be assigned based on current criteria.`);
      }
   };


    return planedTrips;
  }

  /**
   * Check if the driver meets fleet, funding, service area, and starting point requirements.
   *
   * @param {Object} trip - Trip object.
   * @param {Object} driver - Driver object.
   * @param {Number} startingPointThreshold - Maximum acceptable distance (in miles) from the driver's starting point to the trip’s pickup.
   */
  isTripEligibleForDriver(planedTrips, selectedTrip, driver, startingPointThreshold = 10) {

    let isCompatible = false;
    let logs = {};
    // debugger;
    const isFundingSourceWiseExist = this.fundingSourcesWiseTrip(selectedTrip, driver);
    logs = { ...logs, isFundingSourceWiseExist };
    if (isFundingSourceWiseExist) {
      const isDriverShiftWiseExist = this.checkDriverShift(selectedTrip, driver);
      logs = { ...logs, isDriverShiftWiseExist };
      if (isDriverShiftWiseExist) {
        const isServiceAreasWiseExist = this.serviceAreasWiseTrip(selectedTrip, driver);
        logs = { ...logs, isServiceAreasWiseExist };
        if (isServiceAreasWiseExist) {
          const isSpaceTypeWiseExist = this.spaceTypeWiseTrip(selectedTrip, driver);
          logs = { ...logs, isSpaceTypeWiseExist };
          if (isSpaceTypeWiseExist) {
            const isGenderWiseExist = this.genderWiseTrip(selectedTrip, driver);
            logs = { ...logs, isGenderWiseExist };
            if (isGenderWiseExist) {
            if (!planedTrips.driversDistance[driver._id]) planedTrips.driversDistance[driver._id] = 0;
            const isMaxFactor = this.checkTripMaxFactor(planedTrips, driver, planedTrips.driversDistance[driver._id]);
            logs = { ...logs, isMaxFactor };
            if (isMaxFactor) {
              isCompatible = true;
            }
           }
          }
        }
      }
    }
    // // 5. Ensure the driver's starting point is close enough to the trip's pickup location.
    // const { latitude: startLat, longitude: startLon } = driver.startingPointAddress;
    // const { jobOriginLatitude: tripPickupLat, jobOriginLongitude: tripPickupLon } = trip;
    // const distanceFromStart = this.haversineDistance(startLat, startLon, tripPickupLat, tripPickupLon);
    // if (distanceFromStart > startingPointThreshold) {
    //   return false;
    // }

    // create Trip logs
    if (!isCompatible) {
      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({
          trip: selectedTrip,
          logs
        });
      } else {
        planedTrips.tripLogs[driver._id] = {
          driver,
          reasons: [{
            trip: selectedTrip,
            logs
          }]
        }
      }
    }

    return isCompatible;
  }

  checkDriverShift(selectedTrip, driver) {
    let isExist = false;
    const start = moment(this.preData.date).startOf('day');
    const end = moment(this.preData.date).endOf('day');

    if (this.shiftMapper[driver._id] && this.shiftMapper[driver._id].shifts && this.shiftMapper[driver._id].shifts.length) {
      const checkTodayShift = this.shiftMapper[driver._id].shifts.find(item => item.day == start.day() && item.isEnabled);
      if (checkTodayShift && checkTodayShift.checkin) {
        start.set({ hour: checkTodayShift.checkin.split(':')[0], minute: checkTodayShift.checkin.split(':')[1] });
        end.set({ hour: checkTodayShift.checkout.split(':')[0], minute: checkTodayShift.checkout.split(':')[1] });

        if (moment(selectedTrip.scheduleTime).tz(this.user.timeZone).isBetween(start, end) && moment(selectedTrip.appointmentTime).tz(this.user.timeZone).isBetween(start, end)) {
          isExist = true;
        }

      }
    }
    return isExist;
  }

  checkTripMaxFactor(planedTrips, driver, totalDistance) {
    let isExecute = true;
    // total trips check
    if (this.violation) {
      let numberOfTrips = true;
      if (this.violation && this.violation.maxPerRun) {
        if (planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips) {
          if (planedTrips.compatible[driver._id].trips.length >= this.violation.maxPerRun) {
            numberOfTrips = false
          }
        }

      }

      let numberOfTripsMiles = true;
      if (this.violation && this.violation.maxDistancePerRun) {
        if (totalDistance >= this.violation.maxDistancePerRun) {
          numberOfTripsMiles = false
        }
      }

      isExecute = (numberOfTrips && numberOfTripsMiles);
    }

    return isExecute;
  }

  fundingSourcesWiseTrip(selectedTrip, driver) {
    let isExist = false;

    const isfundingSource = driver.fundingSources.some(d => d.name === selectedTrip.cooperate && moment(this.preData.date).isBetween(moment(d.validityRange[0]).tz(this.user.timeZone).subtract(1,'day'), moment(d.validityRange[1]).tz(this.user.timeZone).add(1,'day')));
    if (selectedTrip.cooperate && isfundingSource) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (this.preFleet[driverFleetId] && this.preFleet[driverFleetId].fundingSources && this.preFleet[driverFleetId].fundingSources.includes(selectedTrip.cooperate)) {
          isExist = true;
        }
      }
    }
    return isExist;
  }

  serviceAreasWiseTrip(selectedTrip, driver) {
    let isExist = false;
    if (selectedTrip.serviceArea  && this.shiftMapper[driver._id] && this.shiftMapper[driver._id].serviceAreas.includes(selectedTrip.serviceArea)) {
      isExist = true;
    }
    return isExist;
  }

  spaceTypeWiseTrip(selectedTrip, driver) {
    let isExist = false;

    if (this.violation && !this.violation.isCapacityViolation) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (selectedTrip.spaceType && driverFleetId && this.preFleet[driverFleetId]) {
          isExist = this.preFleet[driverFleetId].capacities.some(capacity => capacity.spaceType === selectedTrip.spaceType);
        }
      }
    } else {
      isExist = true;
    }
    return isExist;
  }

   genderWiseTrip(selectedTrip, driver) {
    let isExist = true;

    if (selectedTrip.priorityClient.isPrefferedFemale) {
      isExist = driver.gender.toLowerCase() === 'female'
    }

    if (selectedTrip.preferredDriver) {
      isExist = driver._id === selectedTrip.priorityClient.preferredDriver;
    }
    return isExist;

  }

  /**
   * Check if a new trip can be scheduled anywhere in a driver’s current route.
   *
   * It ensures that the time gap between trips is sufficient to accommodate travel time (plus a relaxation margin).
   *
   * @param {Object} trip - New trip to evaluate.
   * @param {Array} assignedTrips - Array of trips already assigned to this driver (sorted by scheduleTime).
   * @param {Number} tripCheckMargin - Extra time (in minutes) to allow between trips.
   * @returns {Boolean} - Whether the trip can fit in the route.
   */
  async canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo, tripCheckMargin = 3) {
    let isAllow = false;
    let nearestTo = {};
    const assignedTrips = planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips || [];

    if (assignedTrips.length === 0) {
      isAllow = await this.firstTripPossibility(driver, trip);
      if (isAllow)
       nearestTo = { driverId: driver._id, position: null, index: 0 };
    }

    if (assignedTrips.length !== 0) {
      if (this.violation) {
        if (!isAllow) {
          isAllow = await this.addBeforeTrips(trip, assignedTrips);
          if (isAllow)
            nearestTo = { driverId: driver._id, position: null, index: 0 };
        }

        if (!isAllow) {
          const nearest = await this.betweenTrips(trip, assignedTrips);
          isAllow = nearest.isAllow;
          if (isAllow)
            nearestTo = { driverId: driver._id, position: nearest.to, index: nearest.index };
        }

        if (!isAllow) {
          isAllow = await this.afterTrips(trip, assignedTrips);
          if (isAllow)
            nearestTo = { driverId: driver._id, position: planedTrips.compatible[driver._id].trips[planedTrips.compatible[driver._id].trips.length - 1]._id, index: planedTrips.compatible[driver._id].trips.length };
        }
      } else {
        isAllow = true;
        nearestTo = { driverId: driver._id, position: planedTrips.compatible[driver._id].trips[planedTrips.compatible[driver._id].trips.length - 1]._id };
      }
    }


    // Create logs if trip is not allowed
    if (!isAllow) {
      let logs = {
        isFundingSourceWiseExist: true,
        isDriverShiftWiseExist: true,
        isServiceAreasWiseExist: true,
        isSpaceTypeWiseExist: true,
        istimeWiseTripExist: false,
      };

      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({
          trip: trip,
          logs
        });
      } else {
        planedTrips.tripLogs[driver._id] = {
          driver,
          reasons: [{
            trip: trip,
            logs
          }]
        };
      }
    } else {
      if (!allDriversNearestTo[trip._id]) { allDriversNearestTo[trip._id] = []; }
      allDriversNearestTo[trip._id].push(nearestTo);
    }

    return isAllow;
  }


  async firstTripPossibility(driver, trip) {
    const start = moment(this.preData.date).startOf('day');
    if (driver.shifts && driver.shifts.length) {
      const checkTodayShift = driver.shifts.find(item => item.day == start.day() && item.isEnabled);
      if (checkTodayShift && checkTodayShift.checkin) {
        start.set({ hour: checkTodayShift.checkin.split(':')[0], minute: checkTodayShift.checkin.split(':')[1] });

        const firstTripStartTime = moment(trip.appointmentTime).clone();
        const tripTravelTrip = await this.calculateDistance(
          trip.jobOriginLatitude,
          trip.jobOriginLongitude,
          trip.jobDestinationLatitude,
          trip.jobDestinationLongitude
        );

        firstTripStartTime.subtract(tripTravelTrip.duration, 'minutes');

        if (this.preData.spaceTypes[trip.spaceType]) {
          let loadTime = this.preData.spaceTypes[trip.spaceType].loadTime;
          if (loadTime) {
            loadTime = loadTime.split(':');
            firstTripStartTime.subtract(loadTime[1], 'minutes').subtract(loadTime[0], 'hours');
          }
        }

        const { latitude: startLat, longitude: startLon } = driver.startingPointAddress;

        const travelTimeToFirstTrip = await this.calculateDistance(
          startLat,
          startLon,
          trip.jobOriginLatitude,
          trip.jobOriginLongitude
        );

        firstTripStartTime.subtract(travelTimeToFirstTrip.duration, 'minutes');
        return start.isSameOrBefore(firstTripStartTime);
      }
    }
    return false;
  }

 async addBeforeTrips(trip, assignedTrips) {
    const firstTrip = assignedTrips[0];
    const firstTripStartTime = moment(firstTrip.appointmentTime).clone();

    const secondtravelTrip = await this.calculateDistance(
      firstTrip.jobOriginLatitude,
      firstTrip.jobOriginLongitude,
      firstTrip.jobDestinationLatitude,
      firstTrip.jobDestinationLongitude
    );

    firstTripStartTime.subtract(secondtravelTrip.duration, 'minutes');

    if (this.preData.spaceTypes[firstTrip.spaceType]) {
      let loadTime = this.preData.spaceTypes[firstTrip.spaceType].loadTime;
      if (loadTime) {
        loadTime = loadTime.split(':');
        firstTripStartTime.subtract(loadTime[1], 'minutes').subtract(loadTime[0], 'hours');
      }
    }


    let newTripAPPT = moment(trip.appointmentTime).clone();

    if (this.preData.spaceTypes[trip.spaceType]) {
      let unloadTime = this.preData.spaceTypes[trip.spaceType].unloadTime;
      if (unloadTime) {
        unloadTime = unloadTime.split(':');
        newTripAPPT.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
      }
    }

    if (this.violation && this.violation.breakCushion) {
      newTripAPPT.add(this.violation.breakCushion, 'minutes');
    }

    const travelTimeToFirstTrip = await this.calculateDistance(
      trip.jobDestinationLatitude,
      trip.jobDestinationLongitude,
      firstTrip.jobOriginLatitude,
      firstTrip.jobOriginLongitude
    );
    newTripAPPT.add(travelTimeToFirstTrip.duration, 'minutes');

    return newTripAPPT.isSameOrBefore(firstTripStartTime);
  }

  async afterTrips(trip, assignedTrips) {
    const lastTrip = assignedTrips[assignedTrips.length - 1];
    const lastTripEndTime = moment(lastTrip.appointmentTime).clone();

    if (this.preData.spaceTypes[lastTrip.spaceType]) {
      let unloadTime = this.preData.spaceTypes[lastTrip.spaceType].unloadTime;
      if (unloadTime) {
        unloadTime = unloadTime.split(':');
        lastTripEndTime.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
      }
    }

    if (this.violation && this.violation.breakCushion) {
      lastTripEndTime.add(this.violation.breakCushion, 'minutes');
    }


    let newTripStartTime = moment(trip.appointmentTime).clone();

    if (this.preData.spaceTypes[trip.spaceType]) {
      let loadTime = this.preData.spaceTypes[trip.spaceType].loadTime;
      if (loadTime) {
        loadTime = loadTime.split(':');
        newTripStartTime.subtract(loadTime[1], 'minutes').subtract(loadTime[0], 'hours');
      }
    }

// Previous to New Trip
    const travelTimeToNewTrip = await this.calculateDistance(
      lastTrip.jobDestinationLatitude,
      lastTrip.jobDestinationLongitude,
      trip.jobOriginLatitude,
      trip.jobOriginLongitude
    );

    newTripStartTime.subtract(travelTimeToNewTrip.duration, 'minutes');

//  New Trip pickup to drop off
    const travelTimeNewPickupToDropOff = await this.calculateDistance(
      trip.jobOriginLatitude,
      trip.jobOriginLongitude,
      trip.jobDestinationLatitude,
      trip.jobDestinationLongitude,
    );
    newTripStartTime.subtract(travelTimeNewPickupToDropOff.duration, 'minutes');

    return lastTripEndTime.isSameOrBefore(newTripStartTime);
  }


  async betweenTrips(trip, assignedTrips) {
    let nearest = { to: null, isAllow: false, index: null };

    const tripStartTime = moment(trip.appointmentTime).clone();
    const tripEndTime = moment(trip.appointmentTime).clone();
    const selectedTripDistance = await this.calculateDistance(
      trip.jobOriginLatitude,
      trip.jobOriginLongitude,
      trip.jobDestinationLatitude,
      trip.jobDestinationLongitude
    );
    tripStartTime.subtract(selectedTripDistance.duration, 'minutes');

    if (this.preData.spaceTypes[trip.spaceType]) {
      let loadTime = this.preData.spaceTypes[trip.spaceType].loadTime;
      if (loadTime) {
        loadTime = loadTime.split(':');
        tripStartTime.subtract(loadTime[1], 'minutes').subtract(loadTime[0], 'hours');
      }
    }

    if (this.preData.spaceTypes[trip.spaceType]) {
      let unloadTime = this.preData.spaceTypes[trip.spaceType].unloadTime;
      if (unloadTime) {
        unloadTime = unloadTime.split(':');
        tripEndTime.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
      }
    }


    for (let i = 0; i < assignedTrips.length - 1; i++) {
      const firstTrip = assignedTrips[i];
      const nextTrip = assignedTrips[i + 1];
      // first
      const firstTripEndTime = moment(firstTrip.appointmentTime).clone();

      if (this.preData.spaceTypes[firstTrip.spaceType]) {
        let unloadTime = this.preData.spaceTypes[firstTrip.spaceType].unloadTime;
        if (unloadTime) {
          unloadTime = unloadTime.split(':');
          firstTripEndTime.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
        }
      }

      if (this.violation && this.violation.breakCushion) {
        firstTripEndTime.add(this.violation.breakCushion, 'minutes');
      }


      // next
      const nextTripStartTime = moment(nextTrip.appointmentTime).clone();

      const travelTimeBetween = await this.calculateDistance(
        nextTrip.jobOriginLatitude,
        nextTrip.jobOriginLongitude,
        nextTrip.jobDestinationLatitude,
        nextTrip.jobDestinationLongitude
      );

      nextTripStartTime.subtract(travelTimeBetween.duration, 'minutes');


      if (this.preData.spaceTypes[nextTrip.spaceType]) {
        let loadTime = this.preData.spaceTypes[nextTrip.spaceType].loadTime;
        if (loadTime) {
          loadTime = loadTime.split(':');
          nextTripStartTime.subtract(loadTime[1], 'minutes').subtract(loadTime[0], 'hours');
        }
      }

      if (this.violation && this.violation.breakCushion) {
        nextTripStartTime.subtract(this.violation.breakCushion, 'minutes');
      }



      // check distance between first and trip
      const travelTimeBetweenFirstAndTrip = await this.calculateDistance(
        firstTrip.jobDestinationLatitude,
        firstTrip.jobDestinationLongitude,
        trip.jobOriginLatitude,
        trip.jobOriginLongitude
      );

      firstTripEndTime.add(travelTimeBetweenFirstAndTrip.duration, 'minutes');
      // check distance between trip and next
      const travelTimeBetweenTripAndNext = await this.calculateDistance(
        trip.jobDestinationLatitude,
        trip.jobDestinationLongitude,
        nextTrip.jobOriginLatitude,
        nextTrip.jobOriginLongitude
      );

      nextTripStartTime.subtract(travelTimeBetweenTripAndNext.duration, 'minutes');


      if (firstTripEndTime.isSameOrBefore(tripStartTime) && tripEndTime.isSameOrBefore(nextTripStartTime)) {
        return nearest = { to: firstTrip._id, isAllow: true, index :i };
      }
    }

    return nearest;
  }

  /**
   * From a list of feasible drivers, choose the best one based on the minimal extra travel distance.
   *
   * The extra distance is measured from either the driver's starting point (if no trips are yet assigned)
   * or the last trip’s dropoff location.
   *
   * @param {Array} feasibleDrivers - Array of driver objects that passed eligibility and feasibility checks.
   * @param {Object} trip - The trip to assign.
   * @param {Object} assignments - Mapping from driver._id to an array of assigned trips.
   */
 async chooseDriverForTrip(clientDriverId, feasibleDrivers, allDriversNearestTo, selectedTrip, compatible) {
    // check trip with possition of other trip of drivers.
    let bestDriver = null;
    let minExtraDistance = Infinity;

    for (let driver of feasibleDrivers) {
      let referencePoint = null;
      //  assing A and B to same driver
      if (this.violation && this.violation.prefferedToSameDriver) {
        if (clientDriverId === driver._id) {
          bestDriver = { driver };
          break;
        }
      }

      let index = null;
      // If the driver already has trips, use the last trip's dropoff location.
      if (compatible[driver._id] && compatible[driver._id].trips && compatible[driver._id].trips.length > 0) {
        let lastTrip;
        const nearestTo = allDriversNearestTo[selectedTrip._id].find(item => item.driverId === driver._id);
        if (!nearestTo.position) {
          referencePoint = {
            lat: driver.startingPointAddress.latitude,
            lon: driver.startingPointAddress.longitude,
          };
        } else {
          lastTrip = compatible[driver._id].trips.find(trip => trip._id === nearestTo.position);
          if (nearestTo.index) {
            index = nearestTo.index;
          }
          referencePoint = {
            lat: lastTrip.jobDestinationLatitude,
            lon: lastTrip.jobDestinationLongitude,
          };
        }
      } else {
        // Otherwise, use the driver's starting point.
        referencePoint = {
          lat: driver.startingPointAddress.latitude,
          lon: driver.startingPointAddress.longitude,
        };
      }

      const checkpossibleDistance = await this.calculateDistance(referencePoint.lat, referencePoint.lon, selectedTrip.jobOriginLatitude, selectedTrip.jobOriginLongitude);
      if (checkpossibleDistance.distance < minExtraDistance) {
        minExtraDistance = checkpossibleDistance.distance;
        if (index) {
           bestDriver = { driver, index };
        } else {
          bestDriver = { driver };
        }
      }
    }

    return bestDriver;
  }

  //  checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo) {
  //   const feasibleDrivers = candidateDrivers.filter(async (driver) => {
  //     const result = await this.canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo);
  //     return result;
  //   });

  //   return feasibleDrivers;
  // }

  async checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo) {
    const feasibleDrivers = await Promise.all(
      candidateDrivers.map(async (driver) => {
        const result = await this.canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo);
        return result ? driver : null;
      })
    );
    return feasibleDrivers.filter(driver => driver !== null);
  }


  async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.selectedMethod && this.selectedMethod === true) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2))});
    }
    return resutl;
  }


  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assigTripsService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }
}




